import React from 'react'
import Navbar from '../components/Navbar'
import Products from '../components/Products'

function ProductList() {
  return (
    <>
    <Navbar/>
    <div>
    <Products/>
    </div>
    </>
  )
}

export default ProductList
